export default "__VITE_ASSET__BhNFUoDF__"